import React, { memo } from 'react'
import { FormControlLabel, FormControl, Radio, RadioGroup } from '@mui/material'

import CustomFormLabel from '../forms/customElements/CustomFormLabel'

const CustomRadioGroup = ({ fieldLabel, data, disabled, ...restProps }) => {
  return (
    <FormControl>
      {fieldLabel && <CustomFormLabel>{fieldLabel}</CustomFormLabel>}
      <RadioGroup
        aria-labelledby='demo-controlled-radio-buttons-group'
        name='controlled-radio-buttons-group'
        {...restProps}
      >
        {data.map(({ value, label }, index) => (
          <FormControlLabel
            key={index}
            value={value}
            control={<Radio />}
            label={label}
            disabled={disabled}
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}

export default memo(CustomRadioGroup)
